import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GamificationMainService } from '../../../../services/gamification-main.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-command-center-onboarding',
  templateUrl: './command-center-onboarding.component.html',
  styleUrls: ['./command-center-onboarding.component.scss']
})
export class CommandCenterOnboardingComponent implements OnInit {
  @Input() inputData: any;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() areaChanged: EventEmitter<void> = new EventEmitter<void>();

  gms = null;
  _gms = null;
  isChanging = false;
  intervals = null;
  selectedInterval = null;
  collectButton = false;
  intervalsLabel: string = "";
  isLoading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private gamificationMainService: GamificationMainService,
    private cvLocalizationService: CVLocalizationService
  ) {
    this._gms = this.gamificationMainService.data;

    this.intervals = [
        { value: 3, name: '' },
        { value: 2, name: '' },
        { value: 1, name: '' }
    ];

    this.selectedInterval = this.intervals[0];
  }

  ngOnInit(): void {
    this.localizeIntervals();
    this.gms = this.inputData;
    this.collectButton = this.gms.globalSettings.CollectButton;
    this.selectedInterval = this.intervals.find(x => x.value == this.gms.globalSettings.NumericValue);
  }

  localizeIntervals(): void {
    this.intervals.forEach(interval => {
      if(interval.value > 1){
        interval.name = this.cvLocalizationService.getCachedText("Command_Center", "After_nWeeks", "After {0} Weeks");
        interval.name = interval.name.replace('{0}', interval.value);
      } else {
        interval.name = this.cvLocalizationService.getCachedText("Command_Center", "After_1Week", "After 1 Week");
      } 
    });
  }

  isAreaShown(area: string): boolean {
    var idx = this.gms.settings.HiddenAreas.indexOf(area);
    return idx >= 0 ? false : true;
  }

  areaSelection(area: string, e: any): void {
    var idx = this.gms.settings.HiddenAreas.indexOf(area);

    if (e.target.checked !== undefined) {
      if (idx >= 0 && e.target.checked) {
        this.gms.settings.HiddenAreas.splice(idx, 1);
        this.areaChanged.emit(this.gms.settings.HiddenAreas);
      }

      if (idx < 0 && !e.target.checked) {
        this.gms.settings.HiddenAreas.push(area);
        this.areaChanged.emit(this.gms.settings.HiddenAreas);
      }
    }
  }

  async save() {
    this.isLoading = true;
    
    if (this.gms.globalSettings.GamificationSettingsID == 0) {
        this.gms.globalSettings.GamificationSettingsID = this._gms.globalSettings.GamificationSettingsID;
    }
    this.gms.globalSettings.CollectButton = this.collectButton;
    this.gms.globalSettings.Interval = 4;
    this.gms.globalSettings.NumericValue = this.gms.globalSettings.CollectButton ? this.selectedInterval.value : 3;

    await this.gamificationMainService.saveSettings(this.gms.settings);
    await this.gamificationMainService.saveGlobalSettings(this.gms.globalSettings);
    
    this.isLoading = false;
    this.activeModal.close();
  }
}
